import { render } from "./comprasinventariogeneral.vue?vue&type=template&id=4f8a4ad9&scoped=true"
import script from "./comprasinventariogeneral.vue?vue&type=script&lang=js"
export * from "./comprasinventariogeneral.vue?vue&type=script&lang=js"

import "./comprasinventariogeneral.vue?vue&type=style&index=0&id=4f8a4ad9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f8a4ad9"]])

export default __exports__